import { render } from "./add-currency-dialog.vue?vue&type=template&id=250de1f4&ts=true"
import script from "./add-currency-dialog.ts?vue&type=script&lang=ts"
export * from "./add-currency-dialog.ts?vue&type=script&lang=ts"

import "../dialog.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__